import React from "react";
export const BookingContext = React.createContext({});
export const BookingPopUpContext = React.createContext({});
